import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/permission`;

export const getPermissions = () => {
  return axios.get(API_URL, { headers: authHeader() });
};
